// extracted by mini-css-extract-plugin
module.exports = {"lastSeen":"styles_lastSeen__kxiqi"};